import { render } from "./NewItem.vue?vue&type=template&id=09e4314d"
import script from "./NewItem.vue?vue&type=script&lang=js"
export * from "./NewItem.vue?vue&type=script&lang=js"
script.render = render

export default script